import store from '@state/store'

const currentUser = () => {
  return store.getters['user/currentUser'] || {}
}

// Usuário interno da AAWZ: o MESMO par que o router exige em `only_aawz`
// (`IS_INTERNAL` + `id_interno`), mais estrito no booleano (`=== true`) —
// equivalente porque `internal_user` é bool no backend. Puro, recebe o
// usuário: quem tem `$currentUser()` passa o retorno; quem tem a store
// passa o getter.
export function usuarioInterno(user) {
  return Boolean(user && user.IS_INTERNAL === true && user.id_interno)
}

export const additionalPermissions = {
  treasury: () => {
    return currentUser().IS_FINANCIAL || currentUser().IS_GESTOR
  },
  professionals: () => {
    return currentUser().IS_GESTOR || currentUser().leader
  },
  'manage-professionals': () => {
    return currentUser().IS_GESTOR || currentUser().leader
  },
}
